import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
  /** One line, for a bar: the full state is far too tall to sit in one at phone width. */
  compact?: boolean;
}

export function ErrorState({
  message = "Something went wrong",
  onRetry,
  className,
  compact = false,
}: ErrorStateProps) {
  if (compact) {
    return (
      <div className={cn("flex items-center gap-2 text-left", className)}>
        <AlertCircle className="size-4 shrink-0 text-destructive" />
        <p className="min-w-0 flex-1 text-xs text-destructive">{message}</p>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry} className="h-7 shrink-0 px-2">
            Try again
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col items-center justify-center py-12 text-center", className)}>
      <AlertCircle className="h-10 w-10 text-destructive mb-3" />
      <p className="text-sm text-destructive">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-4">
          Try again
        </Button>
      )}
    </div>
  );
}
